const subdomain = `${window.location.host.split('.')[0]}`
export default subdomain



// WEBPACK FOOTER //
// ./src/utils/subdomain.js